import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../static/icons/trash_icon.svg'


const _hoisted_1 = { class: "cart-gift-card-item" }
const _hoisted_2 = { class: "cart-gift-card-item__toolbar" }
const _hoisted_3 = { class: "cart-gift-card-item__title" }
const _hoisted_4 = { class: "cart-gift-card-item__rows" }
const _hoisted_5 = { class: "cart-gift-card-item__remove-group" }
const _hoisted_6 = { class: "cart-gift-card-item__pricing" }
const _hoisted_7 = { class: "cart-gift-card-item__subtotal" }
const _hoisted_8 = { class: "cart-gift-card-item__subtotal-price" }
const _hoisted_9 = {
  key: 0,
  class: "cart-gift-card-item__pricing-content"
}
const _hoisted_10 = { class: "cart-gift-card-item__price-items" }

import { ref, computed, inject } from 'vue';
import { useCartFunctions } from '@/helpers/cart-actions';
import GiftCardEditorModal from './GiftCardEditor/EditorModal.vue';
import CartItem from './CartItem.vue';
import useContext from '@/composables/useContext';
import CartGiftCardPriceItem from './CartGiftCardPriceItem.vue';
import ConfiguratorChevron from './ProductConfigurator/ConfiguratorChevron.vue';
import useWebsiteTexts from '@/composables/useWebsiteTexts';


export default /*@__PURE__*/_defineComponent({
  __name: 'CartGiftCardItem',
  props: {
  row: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const availableChannels = inject('$availableChannelsReactive');
const { websiteText } = useWebsiteTexts();
const { formatPrice, isAuthorized, navigateToLoginPage } = useContext();
const { removeGroupFromCart } = useCartFunctions();
const isPriceExpanded = ref(false);
const giftCardModal = ref(null);
const giftCardName = computed(() => {
  const giftcard = websiteText('giftcard__giftcard').value || 'giftcard__giftcard';
  return `${giftcard} ${props.row.variantName}` || '';
});

const mappedProduct = computed(() => {
  return {
    variantName: props.row.variantName,
    giftCardName: giftCardLocaleName.value,
    id: props.row.id,
    quantity: props.row.quantity,
    currentPrice: currentPrice.value,
    originalPrice: originalPrice.value,
    articleNumber: props.row.articleNumber,
    giftCardFees: props.row.giftCardFees,
    totalPrice: props.row.totalPrice,
  };
});

const subtotalPrice = computed(() => {
  const fees = props.row.giftCardFees.reduce((acc, curr) => {
    return acc + curr.totalRow;
  }, 0);

  return props.row.totalPrice + fees;
});

const currentPrice = computed(() => {
  return props.row.unitPrice ?? props.row.unitListPrice;
});

const originalPrice = computed(() => {
  return props.row.originalPrice >= currentPrice.value ? props.row.originalPrice : currentPrice.value;
});

const campaignPrice = computed(() => {
  const current = currentPrice.value;
  const original = originalPrice.value;

  if (current < original) {
    return formatPrice(Math.abs(((original - current) / original) * -100), undefined, '', '', 'decimal');
  }

  return 0;
});

const giftCardLocaleName = computed(() => {
  if (!props.row.giftCardInput?.giftCardCurrencyId) return '';
  const giftCardLocale = availableChannels.value?.data
    ?.find(c => c.currencySymbol === props.row.giftCardInput.giftCardCurrencyId) || {};

  if (!giftCardLocale?.name) return undefined;

  return `- ${giftCardLocale.name}`;
});

async function removeProduct() {
  if (!isAuthorized()) {
    navigateToLoginPage();
    return;
  }

  const { _, error } = await removeGroupFromCart(props.row.rowGroupId);
}

function editGiftCard() {
  const input = {
    ...props.row.giftCardInput,
    orderRowSystemId: props.row.id,
  };
  giftCardModal.value?.editGiftCard(input);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(giftCardName.value), 1)
      ]),
      _createElementVNode("button", {
        class: "cart-gift-card-item__edit gift-card-cart-edit secondary-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (editGiftCard()))
      }, _toDisplayString(_unref(websiteText)('global__edit').value), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(CartItem, {
        "campaign-percentage": campaignPrice.value,
        row: props.row
      }, null, 8, ["campaign-percentage", "row"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "cart-gift-card-item__remove-group-button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (removeProduct()))
      }, [
        _createTextVNode(_toDisplayString(_unref(websiteText)('global__remove').value) + " ", 1),
        _cache[3] || (_cache[3] = _createElementVNode("img", {
          src: _imports_0,
          alt: "trash icon"
        }, null, -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: "cart-gift-card-item__pricing-summary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (isPriceExpanded.value = !isPriceExpanded.value))
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, _toDisplayString(_unref(websiteText)('global__subtotal').value), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, _toDisplayString(_unref(formatPrice)(subtotalPrice.value)), 1),
            _createVNode(ConfiguratorChevron, {
              class: "cart-gift-card-item__subtotal-chevron",
              open: isPriceExpanded.value
            }, null, 8, ["open"])
          ])
        ])
      ]),
      (isPriceExpanded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(CartGiftCardPriceItem, { item: mappedProduct.value }, null, 8, ["item"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(GiftCardEditorModal, {
      ref_key: "giftCardModal",
      ref: giftCardModal
    }, null, 512)
  ]))
}
}

})